var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVersoHorizontalCoresSemAssinatura(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 480.79 141.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{clip-path:url(#clippath-6);}.cls-2{clip-path:url(#clippath-7);}.cls-3{clip-path:url(#clippath-15);}.cls-4{clip-path:url(#clippath-4);}.cls-5{fill:url(#linear-gradient-2);}.cls-6{clip-path:url(#clippath-9);}.cls-7{clip-path:url(#clippath-10);}.cls-8{clip-path:url(#clippath-11);}.cls-9{fill:none;}.cls-10{fill:url(#linear-gradient-4);}.cls-11{fill:url(#linear-gradient-3);}.cls-12{clip-path:url(#clippath-1);}.cls-13{isolation:isolate;}.cls-14{clip-path:url(#clippath-5);}.cls-15{clip-path:url(#clippath-8);}.cls-16{clip-path:url(#clippath-3);}.cls-17{clip-path:url(#clippath-12);}.cls-18{clip-path:url(#clippath-14);}.cls-19{clip-path:url(#clippath-2);}.cls-20{clip-path:url(#clippath-13);}.cls-21{fill:url(#linear-gradient);}.cls-22{clip-path:url(#clippath);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M163.83,50.65l13.18,31.4h-26.37l13.19-31.4h0ZM163.55,25.23c-5.71,0-9.92,3.13-12.23,8.29l-33.17,74.9c-.68,1.49-1.23,3-1.23,4.49,0,5.44,4.21,9.79,9.65,9.79,4.35,0,7.88-2.44,9.65-6.53l6.66-15.64h41.87l6.39,14.96c1.9,4.35,5.17,7.2,10.06,7.2,5.57,0,9.92-4.49,9.92-10.06,0-1.36-.41-2.72-1.09-4.22l-33.17-74.9c-2.32-5.16-6.39-8.29-12.1-8.29h-1.22.01Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -241.19,
    y1: 82.25,
    x2: -240.19,
    y2: 82.25,
    gradientTransform: "translate(100714.66 34402.86) scale(417.38 -417.38)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#002a3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#003649"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#004156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#00485e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#004a61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#00485e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#004157"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#00374a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002a3b"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M243.06,45.62h20.8c10.19,0,16.45,4.62,16.45,13.59v.27c0,8.02-5.84,13.46-16.04,13.46h-21.2v-27.32h0ZM232.59,26.73c-5.85,0-10.47,4.62-10.47,10.46v75.04c0,5.85,4.62,10.47,10.47,10.47s10.47-4.62,10.47-10.47v-20.79h16.72l20.39,25.83c2.44,3.12,5.57,5.44,10.33,5.44,5.03,0,9.93-3.81,9.93-9.65,0-3.26-1.36-5.44-3.4-8.02l-14.55-17.67c11.55-4.75,19.04-14,19.04-28.95v-.27c0-8.98-2.86-16.45-8.16-21.75-6.25-6.25-15.63-9.65-27.73-9.65h-33.03v-.02Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -241.19,
    y1: 82.25,
    x2: -240.19,
    y2: 82.25,
    gradientTransform: "translate(100669.32 34387.16) scale(417.19 -417.19)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#002a3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#003649"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#004156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#00485e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#004a61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#00485e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#004157"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#00374a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002a3b"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M335.89,45.62h16.17c10.47,0,16.99,5.03,16.99,14.41v.27c0,8.16-6.11,14.41-16.58,14.41h-16.59v-29.09h0ZM325.43,26.73c-5.85,0-10.47,4.62-10.47,10.46v75.04c0,5.85,4.62,10.47,10.47,10.47s10.47-4.62,10.47-10.47v-18.89h15.9c21.34,0,38.47-11.42,38.47-33.44v-.27c0-19.44-13.73-32.9-36.43-32.9h-28.41Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -241.2,
    y1: 82.24,
    x2: -240.19,
    y2: 82.24,
    gradientTransform: "translate(100390.03 34290.06) scale(416.03 -416.03)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#002a3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#003649"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#004156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#00485e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#004a61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#00485e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#004157"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#00374a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002a3b"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M459.86,36.38v28.01h-38.61v-28.01c0-5.84-4.62-10.46-10.47-10.46s-10.46,4.62-10.46,10.46v75.85c0,5.85,4.62,10.47,10.46,10.47s10.47-4.62,10.47-10.47v-28.55h38.61v28.55c0,5.85,4.62,10.47,10.46,10.47s10.47-4.62,10.47-10.47V36.38c0-5.84-4.62-10.46-10.47-10.46s-10.46,4.62-10.46,10.46Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -241.2,
    y1: 82.25,
    x2: -240.19,
    y2: 82.25,
    gradientTransform: "translate(100729.57 34407.9) scale(417.44 -417.44)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#002a3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#003649"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#004156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#00485e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#004a61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#00485e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#004157"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#00374a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002a3b"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M65.76,46.44L10.57,88.14c-.49.35-.94.72-1.36,1.12-.2.28-1.27,1.86-1.27,3.32,0,1.38.94,2.66,4.45,2.66h33.34l56.62-42.79c.07-.1,1.3-1.79,1.3-3.36,0-1.38-.94-2.66-4.46-2.66h-33.44.01Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 6.58,
    y: 45.02,
    width: 98.7,
    height: 51.54
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M22.43,3.77l-11.85,8.66c-.47.34-.91.7-1.33,1.09.41-.39.85-.75,1.33-1.09L22.43,3.77c2.23-1.6,4.81-2.36,7.39-2.36-2.58,0-5.16.77-7.39,2.36M40.82,7.14c2.7,3.78,3.23,8.43,1.82,12.4,1.41-3.98.88-8.63-1.82-12.4-2.67-3.73-6.83-5.73-11-5.73,4.17,0,8.33,2,11,5.73Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 7.68,
    y: 0.06,
    width: 37.29,
    height: 20.84
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M22.43,3.77l-11.85,8.66c-.47.34-.91.7-1.33,1.09,0,0-1.3,1.75-1.3,3.36,0,1.38.94,2.66,4.45,2.66h30.23c1.41-3.98.88-8.63-1.82-12.4-2.67-3.73-6.83-5.73-11-5.73-2.58,0-5.16.77-7.39,2.36h.01Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 6.58,
    y: 0.06,
    width: 38.38,
    height: 20.84
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1.24,25.29v13.29c1.6,4.31,5.11,7.39,9.98,7.78.44.05.89.08,1.36.08h86.62c3.51,0,4.46,1.28,4.46,2.66,0,1.61-1.3,3.36-1.3,3.36,4.43-2.93,8.94-9.06,8.97-19.46,0-7.06-4.15-12.83-10.94-13.38-.44-.05-.89-.08-1.36-.08H12.4c-3.51,0-4.46-1.28-4.45-2.66,0-1.61,1.3-3.36,1.3-3.36-3.2,2.12-6.45,5.91-8.01,11.77Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-11"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    y: 12.12,
    width: 112.95,
    height: 41.67
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M68.96,122.14c-.49,1.39-.75,2.87-.76,4.37-.02,2.77.82,5.59,2.57,8.04,2.67,3.73,6.83,5.73,10.99,5.73,2.58,0,5.17-.77,7.4-2.37l11.85-8.65c.48-.34.92-.7,1.33-1.09.08-.1,1.3-1.8,1.3-3.36,0-1.38-.94-2.66-4.46-2.66h-30.23.01Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-13"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 66.89,
    y: 120.69,
    width: 38.38,
    height: 20.84
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1.24,101v13.28c1.6,4.31,5.11,7.4,9.98,7.79.44.04.89.07,1.36.07h86.62c3.51,0,4.46,1.28,4.46,2.66,0,1.61-1.3,3.37-1.3,3.37,4.43-2.93,8.94-9.06,8.97-19.47,0-7.06-4.15-12.83-10.94-13.38-.44-.05-.89-.08-1.36-.08H12.4c-3.51,0-4.46-1.28-4.45-2.66,0-1.61,1.3-3.36,1.3-3.36-3.2,2.12-6.45,5.91-8.01,11.77h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-15"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    y: 87.79,
    width: 112.95,
    height: 41.67
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 116.93,
    y: 25.23,
    width: 94.21,
    height: 97.47
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 222.13,
    y: 26.73,
    width: 79.39,
    height: 95.97
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 314.96,
    y: 26.73,
    width: 75.31,
    height: 95.97
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 400.32,
    y: 25.91,
    width: 80.47,
    height: 96.79
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("image", {
    className: "cls-13",
    width: 91,
    height: 48,
    transform: "translate(7.07 96.56) scale(1.08 -1.08)",
    xlinkHref: "data:image/png;base64,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"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("image", {
    className: "cls-13",
    width: 35,
    height: 20,
    transform: "translate(8.09 20.9) scale(1.05 -1.05)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAVCAYAAAAuJkyQAAAACXBIWXMAAAqcAAAKnAH00t8SAAAANklEQVRIie3OoQEAMAzDsGT//9zxEcMVWBeoMzNZoG2T5PyOvAwRQ8QQMUQMEUPEEDFE1oVELoz4BCaUO2bRAAAAAElFTkSuQmCC"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("image", {
    className: "cls-13",
    width: 36,
    height: 20,
    transform: "translate(7.02 20.9) scale(1.05 -1.05)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAAAVCAYAAADB5CeuAAAACXBIWXMAAAqcAAAKnAH00t8SAAAAdklEQVRIie3OwQkCQQxA0f+zbGYUC7AMK7MHrzatlwFFLznuIQ8CYWDC93J/vMzBlgNzwNpZE1/vMebaE2LjVwpTOSlTOYcMYVdSGQGppJAhu7L5+f+8XQWIv8sH0FFVHVXVUVUdVdVRVR1V1VFVHVV1yKhW9QYv3wQmdSURZgAAAABJRU5ErkJggg=="
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("image", {
    className: "cls-13",
    width: 105,
    height: 39,
    transform: "translate(.38 53.79) scale(1.07 -1.07)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGoAAAAoCAYAAAAWsW/wAAAACXBIWXMAAApNAAAKTQG1k+TGAAAIi0lEQVR4nO1aQZLsug0DqL5RjpNlrpVlrpPrpJKMSWRBUqI9+fvfVdarfm3LsmwRIgiyh3/5698EACABErYWaAZbBpqBfW4GjD6zOrb7ONTHPgs0ArbquoG2AOM+xzhHzQMSXHmfxvvkvMxvcs/d7w0jSAMIIFcEICABCAEKKARKUATgAfTx+OS5IPc8lrLfY4+V53eE5zwRe3yPicv3fOEBheccNS7G9xnndV2QhH/+4+/slRje9hXtBepL2gvUl7QXqC9pL1Bf0l6gvqQZkOoWEEhAUErc7NyHJGFg/Xu200MSVhKZ8/49aswLwer4tmPE332359RsKh0ugUKd18MgSIB1f+QYKue1ej6lvF6fnofAY53a72Ss99P9+nxP5jJw7ItjFAzbPFZHTiudZpBqvTWgn1dGUP23uxPKR9M2v1TXOR435u9TIfOfvjPG24r4/YzHmwuAWEutxYl3IEUiaqeIzHlrSKD7MXbSGDfm7TkFIPpZetphPLs3ELj3wHMRwn2N0riA3+v/xNyVMNAERkAgjIJFIJBIiwSFTOpIUKpPPykAGSjBBIQyccvzuXMBKMAAZKydnmPTSrotieURsN4xAWLlXLWzeDNQ3hf1Hthz1zwq5qh3UVttj00gGDkH1Nszk19IY7jOJ8716GQa5zgU+120x9QH9a2AFIi4Q/W53AtsAhFZdUC6uCMNTKloSKAsDYtj4Ly+ap6mjQvUgnqOdnkJgiU99j6TPWggd6+Z5c63ooQIGKo64Q6YISCQBjJyI9XEIYAKrDJ6VyF2ZSKyUgEFos75qFCoqhm7euE5pisMXZGIrkz09VFxQFU0VPd1f1cmdqWi5+qKSARm+/znug5QZhsYKstGXGsDxSJ9W3lsyyDl9Y45MtumtqY8A+gJLMzAAnN7gAGMhgcDsuR0Rr8fgbDcfYYqCxlgAYiQEYq81+t9Px17CoiOSenps5RU3hDaxu1zRYLBGOUkDyAcijS8u2ccrFIRCkBrEC4/ZaYqKYV7lpqkKkfleUTk5ppA/fv6AYvPd01OgmnBimrMIqnLFrhq4auoZwEUYUUDMIFrx3MYbBMui2raG8tVykMx/TiDsVJuaJURaRACCmCBCBguKzojIZ1nAYJL+JRnsSiJAzSVIZOGB1CTpmcN0MsrI+BxPAYFBsqrpqexQEF5Ibf35fXwK2mw63yXIyLrfQ+P8lJ6lopNCQalLMZuuhOw6nhZopDbGlTpszYEGkwDuY6nVEhp3ZjikNjSr89zKEgiLA20+6xFgUERuLI3vQmpyDruBoRP9HslGNZe1R426G57XRtbgjWFRRta22M8ApwUtunwUByvcx3lbebtgYG4EqgN3h8B9d+KUaQgI8x1k69ybOoTUkCkkdMTgsTCkZXaNi8vI2ENDpkLpWGVywV5E4VqyVc0Ge1JjOruYwFmuJibKcISmpqvRcyd+g5gDYxNoDz2uPYuDpAsTrzB9qCmvvLQprUx7z72AnaMmdX79DJHeAmPCdS/fn5yUfUTAmPlrosPaLlr17KcbKXY2Aqq6I9WHtfUiVWwLuAnNk1SHcO0ZX/IQSsFtFT01t4lXJdgZhBSmDhUEnoB4WCDbSrq4xY+KOVpZSQrJUelQZMGfQPyiSMWUHS145oHLDypzPvnjYwriICua8cfC9/A4fLyLgeuO/VBeR/cwe1hDq+4dQMq3NMk4hYFmcs0JQIXkFFjSzNVjiEISW0MnnsBLBJ0T5DCgcppCEFMT2zqCwIIIJhsekKEQQpcYimwpLMwgyI97iQq1qoD3qureOM66s6EI7vDYcO7UNJ4KUohnvhliqS6KGPvGFVADfXoEZvmFKXimgrj/P401WR7ZsQfUJ9fV5qrxMROKspD0uqdR7SAWOURBpXxU9VVfGrKtFUy3ED4ifMsUNCJbgBYCFY+gZPLOBYA34lqkvKdFnpOuI1cq4BCiY2KOb5FwvEkRGBFxhzzNvi47gFzB8OLbVpCl6eU3I7tafXDoTIGNaBs+vSjAHFd4OWgXzVPxa2nPI/rJ9f5AOrQFCCtLQSwRoK3Ut5ZVHlFSXltqSzXlMAgU8W5EMCuIlSERFiiF6zkNDxBKUleWXV+ZxA6uQZZCXG5JfoVDkg3Fdf36+zqayg+RmBV/tQxzEZM26rxljedX36xf+11+JDr5p4xzH2Pscshv5L6PFVgAvXwKJRHCUzD3zxqASC0VCoMe8cXgrmRl7A893nn7M2QwUqWPfWZzBBMHCSVbxgOXw1vBlB8eT5RNAckiCI6HuXYJ1BAcuaQ3juAt0fMvgTo2vlRK8JjaNvxaya9vuMaBhC6DvV5eR09gPIg9+NRrRb1c/1OeHH94NTLhMBAUgKMGxihBMQYow7ojyR1F3U3gOk/SWfjGbtk0f/pnIcSQNMBCjNXyrzrzMFTt1ODigFC/w1EU1/8/vjJjbZgqL+h8Ioh3GAlncWmwiH3x99CnPPjaSrAUgVeBW56VIN4B8pjFCUB0DJ3iayTKxICzcAdzYORcSoEVnVgX7NWBFExPu/v2tne2f3sYNEaT7/xnnz2s232tUdpFDS67jfGDRaABmB7HpxzjO8Y4yrOqSmz8jPpjNvlqU2zcX/36bmKM3+PjbFRbkD1y9jg+YpJXbjUXuBj0dtAo+iJs9DOubY/3u5tj5pd7U18DHgcz65bx68Lp1+P81ax+9F3Jpivcw74+1JVyHfvbWONufdGmWNPqMAwXZ7fgTLwVBX6T732HXwsnE+DnO8ZRs6VecYxarQHbr+b7sesd71dm9//b/6bFc7xnHp749yQc7p5f62uk3/i1Dv7z+fIjib39tx3v/cA9qSjvb/wfkl7gfqS9gL1Je0F6kvaC9SXtBeoL2kvUF/SXqC+pL1AfUl7gfqS9gL1Je0F6kvaC9Tb3va2t73tz9r+B0Q7rRBS1exyAAAAAElFTkSuQmCC"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("image", {
    className: "cls-13",
    width: 36,
    height: 21,
    transform: "translate(68.23 141.53) scale(1 -1)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAAAVCAYAAADB5CeuAAAACXBIWXMAAAsSAAALEgHS3X78AAAAdElEQVRIie3OsQ3DMAxE0e8M7SkyQ2bKGNnA4tnSpbAKlSxd8AHCgYCKvwHs359ZnMPIcPleLXdbttnI5pgrA6ODxIiG1UDCCoYC5utzfYquwHH/uxS0z3t78UAVlVVRWRWVVVFZFZVVUVkVlVVRWY+MKll/ZmNUJnMJlHIAAAAASUVORK5CYII="
  })))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("image", {
    className: "cls-13",
    width: 105,
    height: 40,
    transform: "translate(1.79 129.46) scale(1.05 -1.05)",
    xlinkHref: "data:image/png;base64,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"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVersoHorizontalCoresSemAssinatura);
export default __webpack_public_path__ + "static/media/Versão_horizontal_cores_sem_assinatura.95f45291904f028a8ff9604c3568e7ef.svg";
export { ForwardRef as ReactComponent };